import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/cha_panela';

function ChaPanela() {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ local: '', comida: '', valor_local: '', valor_comida: '', valor_decoracao: '' });
  const [editId, setEditId] = useState(null);

  const fetchDados = async () => {
    const res = await axios.get(API_URL);
    setDados(res.data);
  };

  useEffect(() => {
    fetchDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, form);
    } else {
      await axios.post(API_URL, form);
    }
    setForm({ local: '', comida: '', valor_local: '', valor_comida: '', valor_decoracao: '' });
    setEditId(null);
    fetchDados();
  };

  const handleEdit = (item) => {
    setForm({ local: item.local, comida: item.comida, valor_local: item.valor_local, valor_comida: item.valor_comida, valor_decoracao: item.valor_decoracao });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchDados();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Chá de Panela</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField label="Local" name="local" value={form.local} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Comida servida" name="comida" value={form.comida} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Valor do local" name="valor_local" value={form.valor_local} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <TextField label="Valor alimentação" name="valor_comida" value={form.valor_comida} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <TextField label="Valor decoração" name="valor_decoracao" value={form.valor_decoracao} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
          {editId && <Button onClick={() => { setEditId(null); setForm({ local: '', comida: '', valor_local: '', valor_comida: '', valor_decoracao: '' }); }} sx={{ ml: 2 }}>Cancelar</Button>}
        </form>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Local</TableCell>
            <TableCell>Comida</TableCell>
            <TableCell>Valor do local</TableCell>
            <TableCell>Valor alimentação</TableCell>
            <TableCell>Valor decoração</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dados.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.local}</TableCell>
              <TableCell>{item.comida}</TableCell>
              <TableCell>{item.valor_local}</TableCell>
              <TableCell>{item.valor_comida}</TableCell>
              <TableCell>{item.valor_decoracao}</TableCell>
              <TableCell>
                <Button size="small" onClick={() => handleEdit(item)}>Editar</Button>
                <Button size="small" color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default ChaPanela;
